import React from 'react'
import IdeaPanel from 'components_newui/idea_panel/View'
import FourBoxLoading from 'components_newui/FourBoxLoading'
import noDraftIdeasImg from '../../img/no_draft_idea.png'
import IdeaListFilters from './IdeaListFilters'
import { useInnovateIdeaList } from './useInnovateIdeaList'

/**
 * All Ideas list for Innovate (hackathon) mode, backed by api/v1/innovate/idea/ideaList.
 * Mounted only in that mode, so the legacy All Ideas list never triggers ideaList calls.
 */
const InnovateAllIdeas = ({ classes, isAdmin, fetchInnovateIdeaList }) => {
  const {
    ideas,
    filters,
    applyFilters,
    searchTerm,
    setSearchTerm,
    reset,
    loadMore,
    retry,
    hasMore,
    isLoading,
    isLoadingMore,
    error,
    isFiltered,
  } = useInnovateIdeaList({ isAdmin, fetchIdeaList: fetchInnovateIdeaList })

  const renderList = () => {
    if (isLoading) return <FourBoxLoading />

    // if (error && ideas.length === 0) {
    //   return (
    //     <div className={classes.listMessage} role="alert">
    //       <div className={classes.no_idea_title}>{error}</div>
    //       <button type="button" className={classes.loadmorebtn} onClick={retry}>Retry</button>
    //     </div>
    //   )
    // }

    if (ideas.length === 0) {
      return (
        <div className={classes.listMessage}>
          <img src={noDraftIdeasImg} className={classes.no_idea_img} alt="no idea found" />
          <div className={classes.no_idea_title}>
            {isFiltered ? 'No ideas match the selected filters' : 'No ideas found'}
          </div>
          {isFiltered && (
            <button type="button" className={classes.loadmorebtn} onClick={reset}>Reset</button>
          )}
        </div>
      )
    }

    return (
      <div className={classes.IdeaGrid}>
        {ideas.map((idea) => (
          <IdeaPanel key={idea.id} isInnovate={idea?.isInnovate} urlId={idea.id} idea={idea} />
        ))}
      </div>
    )
  }

  return (
    <main className={classes.background}>
      <div className={classes.content_container}>
        <div className={classes.top_section_text}>
          <p className={classes.title}>All ideas ({isLoading ? '…' : ideas.length})</p>
        </div>
        <IdeaListFilters
          classes={classes}
          appliedFilters={filters}
          onApply={applyFilters}
          onReset={reset}
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
          disabled={isLoading}
        />
      </div>

      <div className={classes.content_container}>{renderList()}</div>

      {/* Errors while loading more keep the ideas already shown. */}
      {/* {error && ideas.length > 0 && (
        <div className={classes.listMessage} role="alert">
          <p>{error}</p>
          <button type="button" className={classes.loadmorebtn} onClick={retry}>Retry</button>
        </div>
      )} */}

      {hasMore && !isLoading && !error && (
        <div className={classes.loadMoreWrapper}>
          <button type="button" className={classes.loadmorebtn} onClick={loadMore} disabled={isLoadingMore}>
            {isLoadingMore ? 'Loading…' : 'Load more'}
          </button>
        </div>
      )}
    </main>
  )
}

export default InnovateAllIdeas